import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-pb-wysiwyg',
    templateUrl: './pb-wysiwyg.component.html',
    styleUrls: ['./pb-wysiwyg.component.scss']
})
export class PbWysiwygComponent implements OnInit {

    @Input() content: any = {};
    @Input() module: any = {};
    @Input() section: any = {};
    padding_top: any = '';
    padding_bottom: any = '';
    item: any = {};
    items: any = [];
    domainUrl: string = environment.webUrl;

    constructor() { }

    ngOnInit(): void {

        this.content.forEach(element => {
            const item = {
                content: element.data,
                alignment: this.determineAlignment(element.alignment),
                padding: this.determinePadding(element.padding),
                type: element.item.type,
                extra_data: null
            };

            if (item.type == 'IMAGE') {
                item.content = this.domainUrl + '/' + element.data;
                if (element?.extra_data) {
                    item.extra_data = JSON.parse(element?.extra_data);
                }
            }

            if (item.type == 'BULLET_LIST' || item.type == 'NUM_LIST') {
                try {
                    item.content = JSON.parse(item.content);
                } catch (err) {
                    item.content = [];
                }
            }

            if (item.type == 'LINK' || item.type == 'BUTTON') {
                try {
                    item.content = JSON.parse(item.content);
                } catch (err) {
                    item.content = {
                        text: '',
                        link: ''
                    };
                }
            }

            this.items.push(item);
        });

        this.padding_top = this.module.padding_top; // Module Padding
        this.padding_bottom = this.module.padding_bottom;

    }

    /**
     * Alignment is returned as LEFT, CENTER, RIGHT
     * Determine class based on response
     */
    determineAlignment(alignment) {

        if (alignment == 'LEFT') {
            return 'text-left';
        } else if (alignment == 'CENTER') {
            return 'text-center';
        } else if (alignment == 'RIGHT') {
            return 'text-right';
        }

    }

    /**
     * Padding is returned as SMALL, MEDIUM, LARGE, XLARGE
     * Determine pixels based on response
     */
    determinePadding(padding) {

        if (padding == 'SMALL') {
            return '10';
        } else if (padding == 'MEDIUM') {
            return '15';
        } else if (padding == 'LARGE') {
            return '30';
        } else if (padding == 'XLARGE') {
            return '60';
        }

    }

}
